import storage from "redux-persist/lib/storage"

export const clearAuthData = () => {
    storage.removeItem('persist:mpg_next_admin_auth_v1')
}